/* eslint-disable complexity, @next/next/no-img-element, react/forbid-component-props, sonarjs/cognitive-complexity */
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import propTypes from 'prop-types';
import React, { useContext, useState } from 'react';
import ReactCookies from 'react-cookies';
import {
  CLOCK,
  REDEEM_LS_QR_CODE_DEV,
  REDEEM_LS_QR_CODE_PROD,
  REDEEM_WOWCHER_QR_CODE_DEV,
  REDEEM_WOWCHER_QR_CODE_PROD,
  SHIELD,
  DISABLED_SHIELD,
  VIP_IMG,
} from '../../config/constants/images';
import COOKIES from '../../config/cookies/cookies';
import {
  CHECK_IN,
  CHECK_OUT,
  CREDIT_REDEEM_DESCRIPTION,
  DELIVERED_ON,
  DELIVERY,
  DELIVERY_DATE,
  DEPOSIT_NON_TRAVEL,
  DEPOSIT_TRANSACTION,
  EXTENDED,
  VOUCHER_PROTECTED,
  GIFTED_TO,
  GIFT_EMAIL_SEND_DATE,
  GIFT_WRAPPED,
  GIFT_WRAPPED_DECRIPTION,
  HOW_TO_REDEEM_WOWCHER,
  HOW_TO_REDEEM_WOWCHER_DESKTOP,
  NOW,
  ORDER_NUMBER,
  PASSENGER,
  REDEEM_WOWCHER_QR_CODE_ALT,
  SAVE,
  SPEEDY_DELIVERY,
  STATUS,
  STATUS_TIP,
  VOUCHER_CODE,
  WAS,
  WOWCHER_VIP_SOCIAL_CUE_ALT,
  DEALS_SAVINGS,
  VOUCHER_PROTECTED_DROPDOWN_TEXT,
  VOUCHER_PROTECTED_DROPDOWN_SUB_HEADING,
  VOUCHER_PROTECTED_DROPDOWN_HEADING,
  VOUCHER_PROTECTED_IMMEDIATE_REFUND_TEXT,
  VOUCHER_PROTECTED_CASH_REFUND_TIME_TEXT,
  CM_MY_VOUCHER_MESSAGE,
  NIGHTS,
  DATE_FLEXIBILITY,
  REDEEMED,
  AUTO_REDEEM_MESSAGE,
} from '../../config/text/text';
import useCheckMobile from '../../helpers/checkMobile';
import { formatCurrency } from '../../helpers/currency';
import { formatShortDate } from '../../helpers/date';
import { usePlaceholderImage } from '../../helpers/image';
import { isWowcherBrand } from '../../helpers/pages';
import {
  isNotYetRedeemed,
  getGiftEmailSendDate,
  getShowCreditUnredeemsCheckbox,
  getShowTip,
  getVoucherCodeDisplay,
  getVoucherPassenger,
  getVoucherStatus,
  showGiftOptions,
  showRedeem,
} from '../../helpers/vouchers';
import ThemeContext from '../../providers/ThemeProvider';
import Message from '../_generic/Message';
import RedeemVoucherInfoModal from '../myaccount/vouchers/RedeemVoucherInfoModal';
import ProtectMyVoucherDropdown from './ProtectMyVoucherDropdown';
import VoucherAccordion from './VoucherAccordion';
import VoucherBcorRedeemMessage from './VoucherBcorRedeemMessage';
import VoucherCreditUnredeems from './VoucherCreditUnredeems';
import VoucherTip from './VoucherTip';
import { DEFAULT_EVENT_KEY, GIFTING_EVENT_KEY } from './constants';

const VoucherItem = ({ voucher, mutate, isPurchase }) => {
  const theme = useContext(ThemeContext);
  const isProduction = process.env.NEXT_PUBLIC_ENVIRONMENT !== 'dev';
  const [toggleState, setToggle] = useState(() => {
    // auto open gifting if just purchased and showGiftForm is true
    if (isPurchase && showGiftOptions(voucher) && voucher.showGiftForm) {
      return GIFTING_EVENT_KEY;
    } else {
      return DEFAULT_EVENT_KEY;
    }
  });
  const isGiftClaimable = voucher.giftType === 'gift-claim';
  const isMobile = useCheckMobile(false);
  const voucherCode = getVoucherCodeDisplay(voucher);
  const passenger = getVoucherPassenger(voucher);
  const [showModal, setShowModal] = useState(false);
  const showTip = getShowTip(voucher);
  const showCreditUnredeemsCheckbox = getShowCreditUnredeemsCheckbox(voucher);
  const giftEmailSendDate = getGiftEmailSendDate(voucher);
  const isExperienceBox = Boolean(voucher.experienceGiftBox);
  const isChannelManagerDeal = voucher.dynamicTravelDeal;
  const isRedeemed = voucher.status === REDEEMED.toLowerCase();
  // Switch VVE
  const ENABLED = ReactCookies.load(COOKIES.vveTest) === 'b';

  return (
    <>
      <div className="voucher" data-testid={voucher.voucherCode}>
        {voucher.deposit && (
          <Message
            iconPosition="left"
            message={
              voucher.hideRedeemInfo
                ? DEPOSIT_NON_TRAVEL
                : DEPOSIT_TRANSACTION[process.env.NEXT_PUBLIC_BRAND]
            }
          />
        )}
        {isChannelManagerDeal &&
          !voucher.giftType &&
          voucher.status.toLowerCase() === 'view' && (
            <Message
              iconPosition="left"
              message={CM_MY_VOUCHER_MESSAGE}
              showIcon
            />
          )}
        {isChannelManagerDeal && voucher.giftType && !isRedeemed && (
          <Message iconPosition="left" message={DATE_FLEXIBILITY} showIcon />
        )}
        {/* Auto Redeem Banner for Channel Manager non-gifting deals */}
        {isChannelManagerDeal &&
          !voucher.giftType &&
          isRedeemed &&
          voucher.autoRedeemed && (
            <Message
              extraClasses="yellow-theme "
              iconPosition="left"
              message={AUTO_REDEEM_MESSAGE}
              showIcon
            />
          )}
        <div className="information">
          {voucher.protectMyVoucherStatus !== 'Unavailable' && (
            <ProtectMyVoucherDropdown
              dropdownText={VOUCHER_PROTECTED_DROPDOWN_TEXT}
              mutate={mutate}
              protectMyVoucherStatus={voucher.protectMyVoucherStatus}
              voucherCopy={{
                cashWorkingDaysRefundText: VOUCHER_PROTECTED_CASH_REFUND_TIME_TEXT,
                heading: VOUCHER_PROTECTED_DROPDOWN_HEADING,
                immediateRefundText: VOUCHER_PROTECTED_IMMEDIATE_REFUND_TEXT,
                subHeading:
                  VOUCHER_PROTECTED_DROPDOWN_SUB_HEADING[
                    process.env.NEXT_PUBLIC_BRAND
                  ],
              }}
              voucherDetails={voucher}
              voucherImage={
                voucher.protectMyVoucherStatus === 'Refunded'
                  ? DISABLED_SHIELD
                  : SHIELD[process.env.NEXT_PUBLIC_BRAND]
              }
              voucherText={VOUCHER_PROTECTED}
            />
          )}
          {voucher.customerVoucherExtensionDate && (
            <div
              className={
                voucher.protectMyVoucherStatus === 'Unavailable'
                  ? `extension`
                  : `extension margin`
              }
            >
              <img
                alt=""
                className="extension-icon"
                src={CLOCK[process.env.NEXT_PUBLIC_BRAND]}
              />
              <span className="extension-content">{EXTENDED}</span>
            </div>
          )}
          <img
            alt={voucher.title}
            className="image"
            onError={usePlaceholderImage}
            src={voucher.image}
          />
          <div className="description">
            <h4 className="title">{voucher.title}</h4>
            {!isGiftClaimable && (
              <div className="money">
                <p className="money-item">
                  <span className="label">{NOW}</span>
                  <span className="value">
                    {formatCurrency(
                      voucher.currency,
                      voucher.price,
                      false,
                      true,
                    )}
                  </span>
                </p>
                {!isChannelManagerDeal &&
                  voucher.showDiscount &&
                  !voucher.hideRedeemInfo && (
                    <>
                      <p className="money-item">
                        <span className="label">{WAS}</span>
                        <span className="value strike">
                          {formatCurrency(
                            voucher.currency,
                            voucher.originalPrice,
                            false,
                            true,
                          )}
                        </span>
                      </p>
                      <p className="money-item">
                        <span className="label">{SAVE}</span>
                        <span className="value">
                          {voucher.discountPercentage}%
                        </span>
                      </p>
                    </>
                  )}
              </div>
            )}
            {isChannelManagerDeal && voucher.numberOfNights && (
              <p className="description-item">
                {NIGHTS}:
                <span className="highlight">{voucher.numberOfNights}</span>
              </p>
            )}
            {!voucher.hideRedeemInfo && (
              <p className="description-item">
                {STATUS}:
                <span className="highlight">{getVoucherStatus(voucher)}</span>
                {showTip && <VoucherTip>{STATUS_TIP(voucher)}</VoucherTip>}
              </p>
            )}

            {voucher.estimatedDeliveryDate && voucher.speedyDelivery && (
              <p className="description-item">
                {DELIVERY}:<span className="highlight">{SPEEDY_DELIVERY}</span>
              </p>
            )}

            {voucher.estimatedDeliveryDate && !voucher.speedyDelivery && (
              <>
                {voucher.deliveryStatus === 'delivered' && (
                  <p className="description-item">
                    {DELIVERED_ON}:
                    <span className="highlight">
                      {formatShortDate(voucher.deliveredDate)}
                    </span>
                  </p>
                )}
                {voucher.deliveryStatus !== 'delivered' && (
                  <p className="description-item">
                    {DELIVERY_DATE}:
                    <span className="highlight">
                      {formatShortDate(voucher.estimatedDeliveryDate)}
                    </span>
                  </p>
                )}
              </>
            )}

            {passenger && (
              <p className="description-item">
                {PASSENGER}:<span className="highlight">{passenger}</span>
              </p>
            )}
            {voucherCode && (
              <p className="description-item">
                {VOUCHER_CODE[process.env.NEXT_PUBLIC_BRAND]}:
                <span className="highlight">{voucherCode}</span>
              </p>
            )}
            <p className="description-item">
              {ORDER_NUMBER}:
              <span className="highlight">{voucher.productOrderId}</span>
            </p>

            {voucher.giftType === 'wrapped' && (
              <p className="description-item">
                {GIFT_WRAPPED}:
                <span className="highlight bold">
                  {GIFT_WRAPPED_DECRIPTION}
                </span>
              </p>
            )}

            {voucher.gifted && (
              <p className="description-item">
                {GIFTED_TO}:
                <span className="highlight bold">
                  {voucher.gift.giftEmail || voucher.gift.recipientName}
                </span>
              </p>
            )}

            {giftEmailSendDate && (
              <div className="description-item">
                {GIFT_EMAIL_SEND_DATE}:
                <span className="highlight">{giftEmailSendDate}</span>
              </div>
            )}

            {!voucher.bookingCalendarOnRedemption && voucher.checkInDate && (
              <p className="description-item">
                {CHECK_IN}:
                <span className="highlight">
                  {formatShortDate(voucher.checkInDate)}
                </span>
              </p>
            )}
            {!voucher.bookingCalendarOnRedemption && voucher.checkOutDate && (
              <p className="description-item">
                {CHECK_OUT}:
                <span className="highlight">
                  {formatShortDate(voucher.checkOutDate)}
                </span>
              </p>
            )}
            {showCreditUnredeemsCheckbox && (
              <VoucherCreditUnredeems mutate={mutate} voucher={voucher} />
            )}
          </div>
          <div>
            {showRedeem(voucher) &&
              !isMobile &&
              !isExperienceBox &&
              !voucher.hideRedeemInfo && (
                <>
                  {!isProduction && (
                    <img
                      alt={REDEEM_WOWCHER_QR_CODE_ALT}
                      className="redeem-voucher-qr"
                      onError={usePlaceholderImage}
                      src={
                        isWowcherBrand()
                          ? REDEEM_WOWCHER_QR_CODE_DEV
                          : REDEEM_LS_QR_CODE_DEV
                      }
                    />
                  )}
                  {isProduction && (
                    <img
                      alt={REDEEM_WOWCHER_QR_CODE_ALT}
                      className="redeem-voucher-qr"
                      onError={usePlaceholderImage}
                      src={
                        isWowcherBrand()
                          ? REDEEM_WOWCHER_QR_CODE_PROD
                          : REDEEM_LS_QR_CODE_PROD
                      }
                    />
                  )}
                  {
                    <div>
                      <div className="how-to-redeem-info-text">
                        {HOW_TO_REDEEM_WOWCHER_DESKTOP + ' '}
                      </div>
                      <FontAwesomeIcon
                        aria-label={HOW_TO_REDEEM_WOWCHER}
                        className="redeem__info"
                        icon={faInfoCircle}
                        onClick={() => setShowModal(true)}
                        // onKeyDown={onModal}
                        role="button"
                        tabIndex={0}
                      />
                      <RedeemVoucherInfoModal
                        onClose={() => setShowModal(false)}
                        setToggle={setToggle}
                        show={showModal}
                        toggleState={toggleState}
                        voucher={voucher}
                      />
                    </div>
                  }
                </>
              )}
          </div>
        </div>

        <div className="discount-text">
          {voucher.vipDiscountAmount > 0 && (
            <div>
              <img
                alt={WOWCHER_VIP_SOCIAL_CUE_ALT}
                className="wowcher-vip-img-summary"
                src={VIP_IMG[process.env.NEXT_PUBLIC_SITE]}
                width="50px"
              />
              &nbsp;
              {DEALS_SAVINGS(
                formatCurrency(
                  voucher.currency,
                  voucher.vipDiscountAmount,
                  false,
                  false,
                ),
              )}
            </div>
          )}
        </div>

        <VoucherAccordion
          isGiftClaimable={isGiftClaimable}
          mutate={mutate}
          setToggle={setToggle}
          theme={theme}
          toggleState={toggleState}
          voucher={voucher}
        />
        {/* Same BCOR message for CM gifted deals as well  */}
        {voucher.bookingCalendarOnRedemption && isNotYetRedeemed(voucher) && (
          <VoucherBcorRedeemMessage giftType={voucher?.giftType} />
        )}
        {showCreditUnredeemsCheckbox && (
          <p className="legal-text">{CREDIT_REDEEM_DESCRIPTION}</p>
        )}
      </div>
      <style jsx>{`
        .voucher {
          position: relative;
          background-color: #f5f5f5;
          margin-bottom: 6px;
          padding: 15px;
        }
        .information {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          margin-bottom: 20px;
          position: relative;
        }

        .image {
          width: 100%;
          border-radius: 5px;
          margin-bottom: 10px;
        }
        .icon {
          margin-left: auto;
          display: inline;
        }
        .extension {
          background-color: rgba(255, 255, 255, 0.7);
          box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
          font-size: 13px;
          padding: 8px;
          position: absolute;
          width: 100%;
        }
        .extension-content {
          color: ${theme.commoncolors.greycharcoal};
          position: relative;
        }
        .extension-icon {
          height: 21px;
          margin-right: 5px;
        }
        .title {
          font-weight: normal;
          margin-bottom: 15px;
        }
        .money {
          display: flex;
          margin-bottom: 15px;
        }
        .money-item {
          line-height: 1em;
          text-align: center;
          margin-right: 20px;
          margin-bottom: 0;
          min-width: 60px;
        }
        .money-item:last-child {
          margin-right: 0;
        }
        .label {
          text-transform: capitalize;
          margin-bottom: 6px;
          display: block;
        }
        .value {
          position: relative;
          color: ${theme.colors.primary};
          font-size: 1.4em;
        }
        .strike:after {
          position: absolute;
          content: '';
          left: -3px;
          top: 50%;
          right: -3px;
          border-top: 1px solid;
          border-color: inherit;
          transform: rotate(-15deg);
          color: #000;
        }
        .highlight {
          margin-left: 3px;
          font-size: 1.1em;
        }
        .highlight.bold {
          font-weight: bold;
        }
        .margin {
          margin-top: 11%;
        }
        .description-item {
          margin-bottom: 0;
        }
        .legal-text {
          margin-top: 20px;
          margin-bottom: 0;
        }
        .discount-text {
          color: ${theme.commoncolors.greendark};
          margin-bottom: 10px;
        }
        @media (min-width: ${theme.breakpoints.mdUp}) {
          .redeem-voucher-qr {
            width: 250px;
            height: calc(100% / 3);
            display: flex;
            justify-content: center;
          }
          .how-to-redeem-info-text {
            font-size: 12px;
            color: ${theme.colors.primary};
            display: inline;
          }
          .margin {
            top: 4.5%;
          }
        }

        @media (min-width: ${theme.breakpoints.lgUp}) {
          .information {
            flex-direction: row;
          }
          .image {
            width: calc(100% / 3 - 10px);
            margin-right: 20px;
            margin-bottom: 0;
          }
          .extension {
            width: calc(100% / 3 - 10px);
          }
          .redeem-voucher-qr {
            width: 150px;
            height: calc(100% / 3);
          }
          .margin {
            margin-top: 5%;
          }
          .how-to-redeem-info-text {
            font-size: 12px;
            color: ${theme.colors.primary};
            display: inline;
          }
        }
      `}</style>
    </>
  );
};

VoucherItem.propTypes = {
  isPurchase: propTypes.bool,
  mutate: propTypes.func,
  voucher: propTypes.object,
};

export default VoucherItem;
